<template>
  <div>
    <router-view/>
    <screen-footer></screen-footer>
  </div>
</template>

<script>
import $ from 'jquery';
import stringsKeys from "@/i18n/strings.json";
import ScreenFooter from "@/components/ScreenFooter";

export default {
  components: {ScreenFooter},
  data: function () {
    return {
      globalSettings: {
        appName: "Gemark",
        logoSrc: "/img/logo.svg",
        phone: {link: "+78129454506", text: "+7 812 945-45-06"},
        email: "info@gemark.ru",
        address: stringsKeys.contacts.address,
      },
      menu: [
        {
          link: '#about',
          name: stringsKeys.menu.about,
        },
        {
          link: '#services',
          name: stringsKeys.menu.services,
        },
        {
          link: '#portfolio',
          name: stringsKeys.menu.portfolio,
        },
        {
          link: '#technologies',
          name: stringsKeys.menu.technologies,
        },
        {
          link: '#contacts',
          name: stringsKeys.menu.contacts,
        },
      ],
    }
  },
  methods: {
    handleScroll: function () {
      if ($(window).scrollTop() >= 300) {
        $('.uplink').animate({opacity: 1}, 50).addClass('d-lg-block');
      } else {
        $('.uplink').animate({opacity: 0}, 50).removeClass('d-lg-block');
      }
    },
  },
  created: function () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.handleScroll);
  },
}
</script>

<style lang="scss">
@import "src/scss/common";
@import "src/scss/typo2";
</style>